var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5316 18.6684L4.73164 5.86836C4.29431 5.43103 4.1738 4.8262 4.46582 4.53418C4.75784 4.24216 5.36267 4.36267 5.8 4.8L18.6 17.6C19.0373 18.0373 19.1578 18.6422 18.8658 18.9342C18.5738 19.2262 17.969 19.1057 17.5316 18.6684Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12197 18.922C3.83663 18.6366 3.96267 18.0373 4.4 17.6L17.2 4.8C17.6373 4.36267 18.2366 4.23663 18.522 4.52197C18.8073 4.80732 18.6813 5.40661 18.2439 5.84395L5.44395 18.6439C5.00661 19.0813 4.40732 19.2073 4.12197 18.922Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cc7c67ac1f963076a290a5b9a6b7e79a.svg";
export { ForwardRef as ReactComponent };